<template>
	<page enable-flex create-button @create="addHandle">
		<view-list work-type="7" view-id="10007" :search="{placeholder: '搜单据编号'}">
			<template #default="{data, index}">
				<view-doc-card :key="index" type="7" :data="data">
					<!--状态-->
					<template #apply_status>
						<c-state dict="flowOrderStateDic" :value="data.apply_status"></c-state>
					</template>

					<!--紧急程度-->
					<template #urgency_level>
						<c-state dict="orderUrgencyDic" :value="data.urgency_level"></c-state>
					</template>
				</view-doc-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_asset_receive',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/assets/receive/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>